

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BASE_URL}api/v1/users`;

const Business = () => {
  const [businessData, setBusinessData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Static fallback data
  const staticData = {
    feature: {
      featureCategory: "News",
      featureTitle: "रैपुरा में कैट के राष्ट्रीय अध्यक्ष का आगमन आज, जिलाध्यक्ष केसरवानी ने लोगो से समय पर पहुंचने एवं स्वागत करने हेतु की अपील",
      featureImage: "/assets/img/news/news31.jpg",
      featureDate: "2025-10-06",
      featureDescription: "रैपुरा में कैट के राष्ट्रीय अध्यक्ष का आगमन आज, जिलाध्यक्ष केसरवानी ने लोगो से समय पर पहुंचने एवं स्वागत करने हेतु की अपील",
      featureType: "business"
    },
    gridItems: [
      {
        gridItemsCategory: "News",
        gridItemsTitle: "ब्रह्माकुमारी अवधेश दीदी को भावपूर्ण श्रद्धांजलि अर्पित",
        gridItemsImage: "/assets/img/news/news32.jpg",
        gridItemsDate: "2017-01-17",
        gridItemsDescription: "ब्रह्माकुमारी अवधेश दीदी को भावपूर्ण श्रद्धांजलि अर्पित",
        gridItemsType: "business"
      },
      {
        gridItemsCategory: "News",
        gridItemsTitle: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
        gridItemsImage: "/assets/img/news/news33.jpg",
        gridItemsDate: "2017-02-10",
        gridItemsDescription: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
        gridItemsType: "business"
      },
      {
        gridItemsCategory: "News",
        gridItemsTitle: "पन्ना टाइगर रिजर्व में तेंदुए की हुई संदिग्ध मौत , शरीर पर कई जगह थे घाव",
        gridItemsImage: "/assets/img/news/news34.jpg",
        gridItemsDate: "2017-03-06",
        gridItemsDescription: "पन्ना टाइगर रिजर्व में तेंदुए की हुई संदिग्ध मौत , शरीर पर कई जगह थे घाव",
        gridItemsType: "business"
      },
      {
        gridItemsCategory: "News",
        gridItemsTitle: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
        gridItemsImage: "/assets/img/news/news35.jpg",
        gridItemsDate: "2017-05-17",
        gridItemsDescription: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
        gridItemsType: "business"
      },
      {
        gridItemsCategory: "News",
        gridItemsTitle: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
        gridItemsImage: "/assets/img/news/news36.jpg",
        gridItemsDate: "2017-08-22",
        gridItemsDescription: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
        gridItemsType: "business"
      },
      {
        gridItemsCategory: "News",
        gridItemsTitle: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार.",
        gridItemsImage: "/assets/img/news/news37.jpg",
        gridItemsDate: "2017-12-30",
        gridItemsDescription: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार.",
        gridItemsType: "business"
      }
    ]
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API_URL}/business/all`);
        console.log("res : business :", res, res.data)
        const data = res.data.data || [];
        if (data.length > 0) {
          const apiData = data[0];
          const mappedData = {
            feature: {
              featureCategory: apiData.feature.featureCategory,
              featureTitle: apiData.feature.featureTitle,
              featureImage: apiData.feature.featureImage,
              featureDate: apiData.feature.featureDate
                ? new Date(apiData.feature.featureDate).toISOString().split("T")[0]
                : "",
              featureDescription: apiData.feature.featureDescription,
              featureType: apiData.feature.featureType,
            },
            gridItems: apiData.gridItems.map((item) => ({
              gridItemsCategory: item.gridItemsCategory,
              gridItemsTitle: item.gridItemsTitle,
              gridItemsImage: item.gridItemsImage,
              gridItemsDate: item.gridItemsDate
                ? new Date(item.gridItemsDate).toISOString().split("T")[0]
                : "",
              gridItemsDescription: item.gridItemsDescription,
              gridItemsType: item.gridItemsType,
            })),
          };
          setBusinessData(mappedData);
        } else {
          setBusinessData(staticData);
        }
      } catch (error) {
        console.error("API fetch failed, using static data:", error);
        setBusinessData(staticData);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  const { feature, gridItems } = businessData;

  return (
    <>
      <section className="bg-body section-space-less30">
        <div className="container">
          <div className="ne-isotope">
            <div className="row">
              <div className="col-12">
                <div className="topic-border color-azure-radiance mb-30">
                  <div className="topic-box-lg color-azure-radiance">व्यापार की ताज़ा खबरें</div>
                </div>
              </div>
            </div>
            <div className="featuredContainer">
              <div className="row tenies">
                <div className="col-xl-8 col-lg-5 col-md-6 col-sm-12">
                  <div className="row keep-items-4-md">
                    {gridItems.map((item, i) => (
                      <div key={i} className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
                        <div className="mb-25 position-relative">
                          <Link className="img-opacity-hover" to="/news_info">
                            <img src={item.gridItemsImage} alt="news" className="img-fluid width-100 mb-15" />
                          </Link>
                          <div className="topic-box-top-xs">
                            <div className="topic-box-sm color-cod-gray mb-20">{item.gridItemsCategory}</div>
                          </div>
                          <div className="post-date-dark">
                            <ul>
                              <li>
                                <span>
                                  <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />
                                </span>{item.gridItemsDate}
                              </li>
                              <li>
                                <i className="fa fa-share-alt" style={{ fontSize: "20px", color: "black" }} />
                              </li>
                              <i className="fa fa-thumbs-o-up" style={{ fontSize: "20px", color: "black", margin: "10px" }} />
                              <i className="fa fa-commenting-o" style={{ fontSize: "20px", color: "black", margin: "10px" }} />
                            </ul>
                          </div>
                          <h3 className="title-medium-dark size-md">
                            <Link to="/news_info">{item.gridItemsTitle}</Link>
                          </h3>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-xl-4 col-lg-7 col-md-6 col-sm-12">
                  <div className="img-overlay-70 img-scale-animate mb-30">
                    <img src={feature.featureImage} alt="news" className="img-fluid width-100" />
                    <div className="topic-box-top-lg">
                      <div className="topic-box-sm color-cod-gray mb-20">{feature.featureCategory}</div>
                    </div>
                    <div className="mask-content-lg">
                      <div className="post-date-light">
                        <ul>
                          <li>
                            <span>
                              <i className="fa fa-calendar" style={{ color: "white" }} aria-hidden="true" />
                            </span>{feature.featureDate}
                          </li>
                          <li>
                            <i className="fa fa-share-alt" style={{ fontSize: "25px" }} />
                          </li>
                          <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
                          <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
                        </ul>
                      </div>
                      <h2 className="title-medium-light size-lg">
                        <Link to="/news_info">{feature.featureTitle}</Link>
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Business;
